export default "__VITE_PUBLIC_ASSET__40100718__"